import { Outlet } from 'react-router-dom'

import { AvailableModules } from 'generated/featureDefinitions'
import {
  GetModuleAvailabilitiesDocument,
  MyTrainingsCatalogDetailDocument,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'
import { isModuleAvailabilityEnabled } from 'modules/core/lib/isModuleAvailabilityEnabled'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

export default function CatalogDetail() {
  const { data, error, loading } = usePageQuery()
  const training = data?.trainings.trainingsConnection.nodes.at(0)
  const { company } = useCurrentSession()

  const { data: featureData } = useQuery(GetModuleAvailabilitiesDocument, {
    fetchPolicy: 'cache-first',
    variables: {
      ids: [AvailableModules.lms],
      companyId: company.id,
    },
  })

  const moduleAvailabilities = featureData?.companies.moduleAvailabilities ?? []
  const hasContentFF = isModuleAvailabilityEnabled(moduleAvailabilities, AvailableModules.lms)

  return (
    <ResponsivePage.Body showHeader={false} loading={loading} error={error} authorized={!!training}>
      <Outlet
        context={{
          training,
          classFiles: data?.trainings.trainingClassFilesConnection.nodes,
          trainingFiles: data?.trainings.trainingFilesConnection.nodes,
          certificates: data?.trainings.trainingMembershipsConnection.nodes.flatMap(
            (membership) => membership.trainingMembershipFilesConnection.nodes
          ),
          hasContentFF,
        }}
      />
    </ResponsivePage.Body>
  )
}

function usePageQuery() {
  const { trainingId } = useStrictParams<'trainingId'>()
  const {
    employee: { id: employeeId },
  } = useCurrentSession()
  return useQuery(MyTrainingsCatalogDetailDocument, {
    variables: { employeeId, trainingId: trainingId },
  })
}
